export enum AsyncState {
    IDLE,
    IS_LOADING,
    IS_SUCCESS,
    IS_ERROR
}
